<template>
	<div class="avatar-selector flex-start--center" ref="avatar_selector_ref">
		<slot>
			<AppAvatar :size="100" />
		</slot>
		<input ref="file_input_ref" type="file" class="display-none" @change="onFileSelected" accept="image/png, image/jpeg, image/gif" />
		<div class="avatar-menu-handle"></div>
		<div class="ml-3">
			<v-menu offset-y attach=".avatar-menu-handle">
				<template v-slot:activator="{ on, attrs }">
					<OutlinedButton class="menu-trigger" v-bind="attrs" v-on="on"> {{ buttonText }} </OutlinedButton>
				</template>
				<v-list class="menu-container">
					<v-list-item v-for="(item, index) in items" :key="index">
						<OutlinedButton class="menu-item" :class="{ [item.class]: true }" @click="item.callback">{{ item.title }}</OutlinedButton>
					</v-list-item>
				</v-list>
			</v-menu>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ImageSelector',
	components: {},
	props: {
		showRemove: { type: Boolean, default: true },
		buttonText: { type: String, default: 'Change avatar' },
	},
	computed: {
		items() {
			return [
				{
					title: 'Upload',
					callback: () => this.$refs['file_input_ref'].click(),
					class: 'main-button',
				},
				this.showRemove
					? {
							title: 'Remove',
							callback: () => this.updateNewAvatar(null),
					  }
					: null,
			].filter((a) => !!a);
		},
	},
	methods: {
		onFileSelected(e) {
			this.updateNewAvatar(e.target.files[0]);
		},
		updateNewAvatar(newAvatarSrc) {
			this.$emit('onFileSelected', newAvatarSrc);
		},
	},
};
</script>

<style scoped lang="scss">
.avatar-selector {
	.menu-container {
		width: 300px;

		.menu-trigger {
			border-color: #d1d9e9 !important;
			color: #3b3b3b !important;
		}
		.menu-item {
			width: 100%;

			&.main-button {
				border-color: #6360ef !important;
				color: #6360ef !important;
			}
		}
	}
}
</style>
